import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-resultadosdetalle',
  templateUrl: './resultadosdetalle.component.html',
  styleUrls: ['./resultadosdetalle.component.css']
})
export class ResultadosdetalleComponent implements OnInit {
  id:any
  constructor(private route: ActivatedRoute,
    private router: Router) { }

  ngOnInit(): void {
    window.scroll(0, 300);
    this.id = this.route.snapshot.queryParams.id;
   
  }

}
